// GENERATED FILE — do not edit by hand.
// Regenerate with: node scripts/import-hub-pois.mjs
//
// Named locations from the WARDOGS Hub community map (wardogshub.gg), converted
// from normalised positions into game coordinates. Calibrated against tower
// positions from the WARDOGS Calculator dataset; residual RMS about 35 m.
//
// BULKHEAD has published no official place names, so these are community
// working names and are liable to change. Underlying game data is
// (c) BULKHEAD / Team17.

import type { GameCoord } from "@/engine/coords.ts";

export type PlaceKind = "tower" | "landmark";

export interface PlaceName {
  readonly id: string;
  readonly mapId: string;
  readonly label: string;
  readonly kind: PlaceKind;
  readonly at: GameCoord;
}

export const PLACE_NAMES: readonly PlaceName[] = [
  {
    id: "bakurani-abandoned-twr-1",
    mapId: "bakurani",
    label: "Abandoned TWR 1",
    kind: "landmark",
    at: { x: 72.76, y: 72.26 },
  },
  {
    id: "bakurani-abandoned-twr-2",
    mapId: "bakurani",
    label: "Abandoned TWR 2",
    kind: "landmark",
    at: { x: 77.03, y: 78.24 },
  },
  {
    id: "bakurani-abandoned-twr-3",
    mapId: "bakurani",
    label: "Abandoned TWR 3",
    kind: "landmark",
    at: { x: 78.82, y: 63.95 },
  },
  {
    id: "bakurani-abandoned-twr-4",
    mapId: "bakurani",
    label: "Abandoned TWR 4",
    kind: "landmark",
    at: { x: 87.38, y: 67.74 },
  },
  {
    id: "bakurani-apartment-hillside",
    mapId: "bakurani",
    label: "Apartment Hillside",
    kind: "landmark",
    at: { x: 80.13, y: 79.66 },
  },
  {
    id: "bakurani-apartments",
    mapId: "bakurani",
    label: "Apartments",
    kind: "landmark",
    at: { x: 80.41, y: 75.04 },
  },
  {
    id: "bakurani-bridge-hill",
    mapId: "bakurani",
    label: "Bridge Hill",
    kind: "landmark",
    at: { x: 77.59, y: 69.16 },
  },
  {
    id: "bakurani-containers-and-factory",
    mapId: "bakurani",
    label: "Containers and Factory",
    kind: "landmark",
    at: { x: 79.22, y: 71.41 },
  },
  {
    id: "bakurani-forest-quarry-1",
    mapId: "bakurani",
    label: "Forest Quarry 1",
    kind: "landmark",
    at: { x: 85.26, y: 66.58 },
  },
  {
    id: "bakurani-forest-quarry-2",
    mapId: "bakurani",
    label: "Forest Quarry 2",
    kind: "landmark",
    at: { x: 86.58, y: 67.65 },
  },
  {
    id: "bakurani-green-farmland",
    mapId: "bakurani",
    label: "Green Farmland",
    kind: "landmark",
    at: { x: 70.46, y: 71.7 },
  },
  {
    id: "bakurani-green-mountain",
    mapId: "bakurani",
    label: "Green Mountain",
    kind: "landmark",
    at: { x: 73.02, y: 70.79 },
  },
  {
    id: "bakurani-hill-town",
    mapId: "bakurani",
    label: "Hill Town",
    kind: "landmark",
    at: { x: 78.93, y: 67.1 },
  },
  {
    id: "bakurani-hillside-houses",
    mapId: "bakurani",
    label: "Hillside Houses",
    kind: "landmark",
    at: { x: 79.51, y: 78.03 },
  },
  {
    id: "bakurani-hillside-top",
    mapId: "bakurani",
    label: "Hillside Top",
    kind: "landmark",
    at: { x: 81.81, y: 78.41 },
  },
  {
    id: "bakurani-lumber-farmlands",
    mapId: "bakurani",
    label: "Lumber Farmlands",
    kind: "landmark",
    at: { x: 82.18, y: 61.34 },
  },
  {
    id: "bakurani-lumber-hills-2",
    mapId: "bakurani",
    label: "Lumber Hills 2",
    kind: "landmark",
    at: { x: 84.49, y: 68.38 },
  },
  {
    id: "bakurani-lumberyard-forest-1",
    mapId: "bakurani",
    label: "Lumberyard Forest 1",
    kind: "landmark",
    at: { x: 83.09, y: 65.43 },
  },
  {
    id: "bakurani-lumberyard-forest-2",
    mapId: "bakurani",
    label: "Lumberyard Forest 2",
    kind: "landmark",
    at: { x: 83.86, y: 63.65 },
  },
  {
    id: "bakurani-lumberyard-forest-3",
    mapId: "bakurani",
    label: "Lumberyard Forest 3",
    kind: "landmark",
    at: { x: 85.8, y: 65.71 },
  },
  {
    id: "bakurani-lumberyard-house",
    mapId: "bakurani",
    label: "Lumberyard House",
    kind: "landmark",
    at: { x: 83.96, y: 64.84 },
  },
  {
    id: "bakurani-lumberyard-north",
    mapId: "bakurani",
    label: "Lumberyard North",
    kind: "landmark",
    at: { x: 82.44, y: 68.79 },
  },
  {
    id: "bakurani-lumberyard-south",
    mapId: "bakurani",
    label: "Lumberyard South",
    kind: "landmark",
    at: { x: 82.48, y: 67.27 },
  },
  {
    id: "bakurani-market-swamp",
    mapId: "bakurani",
    label: "Market Swamp",
    kind: "landmark",
    at: { x: 82.76, y: 74.73 },
  },
  {
    id: "bakurani-mindori-hillside-1",
    mapId: "bakurani",
    label: "Mindori Hillside 1",
    kind: "landmark",
    at: { x: 88.81, y: 68.2 },
  },
  {
    id: "bakurani-mindori-hillside-2",
    mapId: "bakurani",
    label: "Mindori Hillside 2",
    kind: "landmark",
    at: { x: 88.15, y: 66.31 },
  },
  {
    id: "bakurani-mindori-village",
    mapId: "bakurani",
    label: "Mindori Village",
    kind: "landmark",
    at: { x: 89.38, y: 70.19 },
  },
  {
    id: "bakurani-north-river",
    mapId: "bakurani",
    label: "North River",
    kind: "landmark",
    at: { x: 78.75, y: 74.81 },
  },
  {
    id: "bakurani-pond",
    mapId: "bakurani",
    label: "Pond",
    kind: "landmark",
    at: { x: 80.38, y: 63.59 },
  },
  {
    id: "bakurani-red-sunflower-fields",
    mapId: "bakurani",
    label: "Red Sunflower Fields",
    kind: "landmark",
    at: { x: 90.21, y: 72.65 },
  },
  {
    id: "bakurani-residential",
    mapId: "bakurani",
    label: "Residential",
    kind: "landmark",
    at: { x: 81.33, y: 72.85 },
  },
  {
    id: "bakurani-riverside-forest",
    mapId: "bakurani",
    label: "Riverside Forest",
    kind: "landmark",
    at: { x: 74.85, y: 65.22 },
  },
  {
    id: "bakurani-scrubland-east",
    mapId: "bakurani",
    label: "Scrubland East",
    kind: "landmark",
    at: { x: 82.86, y: 70.26 },
  },
  {
    id: "bakurani-scrubland-west",
    mapId: "bakurani",
    label: "Scrubland West",
    kind: "landmark",
    at: { x: 81.19, y: 71.38 },
  },
  {
    id: "bakurani-south-town-farmlands",
    mapId: "bakurani",
    label: "South Town Farmlands",
    kind: "landmark",
    at: { x: 78.34, y: 62.62 },
  },
  {
    id: "bakurani-south-town-forest-east",
    mapId: "bakurani",
    label: "South Town Forest East",
    kind: "landmark",
    at: { x: 80.69, y: 65.4 },
  },
  {
    id: "bakurani-south-town-forest-west",
    mapId: "bakurani",
    label: "South Town Forest West",
    kind: "landmark",
    at: { x: 77.96, y: 65.37 },
  },
  {
    id: "bakurani-south-west-river",
    mapId: "bakurani",
    label: "South West River",
    kind: "landmark",
    at: { x: 77, y: 72.31 },
  },
  {
    id: "bakurani-sunflower-church",
    mapId: "bakurani",
    label: "Sunflower Church",
    kind: "landmark",
    at: { x: 84.59, y: 72.12 },
  },
  {
    id: "bakurani-sunflower-north",
    mapId: "bakurani",
    label: "Sunflower North",
    kind: "landmark",
    at: { x: 87.01, y: 73.02 },
  },
  {
    id: "bakurani-sunflowers-center",
    mapId: "bakurani",
    label: "Sunflowers Center",
    kind: "landmark",
    at: { x: 85.82, y: 71.42 },
  },
  {
    id: "bakurani-sunflowers-house",
    mapId: "bakurani",
    label: "Sunflowers House",
    kind: "landmark",
    at: { x: 87.44, y: 71.43 },
  },
  {
    id: "bakurani-sunflowers-south",
    mapId: "bakurani",
    label: "Sunflowers South",
    kind: "landmark",
    at: { x: 86.01, y: 69.94 },
  },
  {
    id: "bakurani-sunflowers-tower",
    mapId: "bakurani",
    label: "Sunflowers Tower",
    kind: "tower",
    at: { x: 84.64, y: 73.68 },
  },
  {
    id: "bakurani-tower-1",
    mapId: "bakurani",
    label: "Tower 1",
    kind: "tower",
    at: { x: 80.47, y: 70.02 },
  },
  {
    id: "bakurani-tower-2",
    mapId: "bakurani",
    label: "Tower 2",
    kind: "tower",
    at: { x: 77.3, y: 70.23 },
  },
  {
    id: "bakurani-tower-3",
    mapId: "bakurani",
    label: "Tower 3",
    kind: "tower",
    at: { x: 77.22, y: 73.43 },
  },
  {
    id: "bakurani-tower-4",
    mapId: "bakurani",
    label: "Tower 4",
    kind: "tower",
    at: { x: 83.52, y: 73.12 },
  },
  {
    id: "bakurani-tower-5-l",
    mapId: "bakurani",
    label: "Tower 5 L",
    kind: "tower",
    at: { x: 82.24, y: 67.76 },
  },
  {
    id: "bakurani-tower-7",
    mapId: "bakurani",
    label: "Tower 7",
    kind: "tower",
    at: { x: 85.5, y: 67.98 },
  },
  {
    id: "bakurani-water-silos-2",
    mapId: "bakurani",
    label: "Water Silos 2",
    kind: "landmark",
    at: { x: 75.84, y: 67.2 },
  },
  {
    id: "bakurani-water-storage-outcrop",
    mapId: "bakurani",
    label: "Water Storage Outcrop",
    kind: "landmark",
    at: { x: 74.11, y: 69.73 },
  },
  {
    id: "bakurani-west-forest-central",
    mapId: "bakurani",
    label: "West Forest Central",
    kind: "landmark",
    at: { x: 74.38, y: 77.98 },
  },
  {
    id: "bakurani-west-forest-hillside-1",
    mapId: "bakurani",
    label: "West Forest Hillside 1",
    kind: "landmark",
    at: { x: 72.11, y: 75.27 },
  },
  {
    id: "bakurani-west-forest-house-2",
    mapId: "bakurani",
    label: "West Forest House 2",
    kind: "landmark",
    at: { x: 75.76, y: 75.89 },
  },
  {
    id: "bakurani-west-forest-house-3",
    mapId: "bakurani",
    label: "West Forest House 3",
    kind: "landmark",
    at: { x: 73.93, y: 73.74 },
  },
  {
    id: "bakurani-west-forest-house-4",
    mapId: "bakurani",
    label: "West Forest House 4",
    kind: "landmark",
    at: { x: 74.22, y: 75.18 },
  },
  {
    id: "bakurani-west-forest-north",
    mapId: "bakurani",
    label: "West Forest North",
    kind: "landmark",
    at: { x: 75.12, y: 79.78 },
  },
  {
    id: "bakurani-west-forest-pylon",
    mapId: "bakurani",
    label: "West Forest Pylon",
    kind: "landmark",
    at: { x: 75.59, y: 74.94 },
  },
  {
    id: "bakurani-west-hill-woods",
    mapId: "bakurani",
    label: "West Hill Woods",
    kind: "landmark",
    at: { x: 76.8, y: 74.44 },
  },
  {
    id: "ozeti-apartment-garages",
    mapId: "ozeti",
    label: "Apartment Garages",
    kind: "landmark",
    at: { x: 95.02, y: 62.91 },
  },
  {
    id: "ozeti-apartments",
    mapId: "ozeti",
    label: "Apartments",
    kind: "landmark",
    at: { x: 95.59, y: 61.88 },
  },
  {
    id: "ozeti-church-top",
    mapId: "ozeti",
    label: "Church Top",
    kind: "landmark",
    at: { x: 101.24, y: 63.13 },
  },
  {
    id: "ozeti-deforested-1",
    mapId: "ozeti",
    label: "Deforested 1",
    kind: "landmark",
    at: { x: 100.46, y: 69.08 },
  },
  {
    id: "ozeti-farm-1",
    mapId: "ozeti",
    label: "Farm 1",
    kind: "landmark",
    at: { x: 95.28, y: 65.37 },
  },
  {
    id: "ozeti-farm-2",
    mapId: "ozeti",
    label: "Farm 2",
    kind: "landmark",
    at: { x: 96.95, y: 69.32 },
  },
  {
    id: "ozeti-farm-3",
    mapId: "ozeti",
    label: "Farm 3",
    kind: "landmark",
    at: { x: 104, y: 66.54 },
  },
  {
    id: "ozeti-farm-4",
    mapId: "ozeti",
    label: "Farm 4",
    kind: "landmark",
    at: { x: 106.52, y: 66.18 },
  },
  {
    id: "ozeti-farm-5",
    mapId: "ozeti",
    label: "Farm 5",
    kind: "landmark",
    at: { x: 93.73, y: 62.91 },
  },
  {
    id: "ozeti-farm-6",
    mapId: "ozeti",
    label: "Farm 6",
    kind: "landmark",
    at: { x: 91.17, y: 62.82 },
  },
  {
    id: "ozeti-farm-7",
    mapId: "ozeti",
    label: "Farm 7",
    kind: "landmark",
    at: { x: 92.17, y: 64.28 },
  },
  {
    id: "ozeti-farm-8",
    mapId: "ozeti",
    label: "Farm 8",
    kind: "landmark",
    at: { x: 92.71, y: 66.41 },
  },
  {
    id: "ozeti-farm-9",
    mapId: "ozeti",
    label: "Farm 9",
    kind: "landmark",
    at: { x: 91.62, y: 67.4 },
  },
  {
    id: "ozeti-forest-1",
    mapId: "ozeti",
    label: "Forest 1",
    kind: "landmark",
    at: { x: 99.71, y: 59.43 },
  },
  {
    id: "ozeti-forest-10",
    mapId: "ozeti",
    label: "Forest 10",
    kind: "landmark",
    at: { x: 90.57, y: 59.21 },
  },
  {
    id: "ozeti-forest-11",
    mapId: "ozeti",
    label: "Forest 11",
    kind: "landmark",
    at: { x: 92.48, y: 60.55 },
  },
  {
    id: "ozeti-forest-12",
    mapId: "ozeti",
    label: "Forest 12",
    kind: "landmark",
    at: { x: 99.48, y: 70.38 },
  },
  {
    id: "ozeti-forest-13",
    mapId: "ozeti",
    label: "Forest 13",
    kind: "landmark",
    at: { x: 94.75, y: 68.08 },
  },
  {
    id: "ozeti-forest-2",
    mapId: "ozeti",
    label: "Forest 2",
    kind: "landmark",
    at: { x: 96.51, y: 61.12 },
  },
  {
    id: "ozeti-forest-3",
    mapId: "ozeti",
    label: "Forest 3",
    kind: "landmark",
    at: { x: 97.06, y: 67.28 },
  },
  {
    id: "ozeti-forest-4",
    mapId: "ozeti",
    label: "Forest 4",
    kind: "landmark",
    at: { x: 102.17, y: 68.25 },
  },
  {
    id: "ozeti-forest-5",
    mapId: "ozeti",
    label: "Forest 5",
    kind: "landmark",
    at: { x: 105.22, y: 58.67 },
  },
  {
    id: "ozeti-forest-6",
    mapId: "ozeti",
    label: "Forest 6",
    kind: "landmark",
    at: { x: 103.77, y: 55.94 },
  },
  {
    id: "ozeti-forest-7",
    mapId: "ozeti",
    label: "Forest 7",
    kind: "landmark",
    at: { x: 97.92, y: 56.22 },
  },
  {
    id: "ozeti-forest-8",
    mapId: "ozeti",
    label: "Forest 8",
    kind: "landmark",
    at: { x: 92.89, y: 55.44 },
  },
  {
    id: "ozeti-forest-9",
    mapId: "ozeti",
    label: "Forest 9",
    kind: "landmark",
    at: { x: 89.5, y: 57.17 },
  },
  {
    id: "ozeti-grassland-1",
    mapId: "ozeti",
    label: "Grassland 1",
    kind: "landmark",
    at: { x: 108.74, y: 62.57 },
  },
  {
    id: "ozeti-hillside-church-1",
    mapId: "ozeti",
    label: "Hillside Church 1",
    kind: "landmark",
    at: { x: 100.15, y: 62.25 },
  },
  {
    id: "ozeti-hillside-church-2",
    mapId: "ozeti",
    label: "Hillside Church 2",
    kind: "landmark",
    at: { x: 102.29, y: 64.32 },
  },
  {
    id: "ozeti-hillside-church-3",
    mapId: "ozeti",
    label: "Hillside Church 3",
    kind: "landmark",
    at: { x: 101.83, y: 61.93 },
  },
  {
    id: "ozeti-hillside-church-4",
    mapId: "ozeti",
    label: "Hillside Church 4",
    kind: "landmark",
    at: { x: 102.78, y: 63.48 },
  },
  {
    id: "ozeti-hillside-church-5",
    mapId: "ozeti",
    label: "Hillside Church 5",
    kind: "landmark",
    at: { x: 104.43, y: 62.33 },
  },
  {
    id: "ozeti-hillside-church-6",
    mapId: "ozeti",
    label: "Hillside Church 6",
    kind: "landmark",
    at: { x: 105.13, y: 64.2 },
  },
  {
    id: "ozeti-industrial-1",
    mapId: "ozeti",
    label: "Industrial 1",
    kind: "landmark",
    at: { x: 90.66, y: 60.98 },
  },
  {
    id: "ozeti-lumberyard",
    mapId: "ozeti",
    label: "Lumberyard",
    kind: "landmark",
    at: { x: 101.39, y: 58.45 },
  },
  {
    id: "ozeti-misc-stadium-front",
    mapId: "ozeti",
    label: "Misc Stadium Front",
    kind: "landmark",
    at: { x: 98.18, y: 64.46 },
  },
  {
    id: "ozeti-misc-stadium-parking",
    mapId: "ozeti",
    label: "Misc Stadium Parking",
    kind: "landmark",
    at: { x: 96.77, y: 64.91 },
  },
  {
    id: "ozeti-pool",
    mapId: "ozeti",
    label: "Pool",
    kind: "landmark",
    at: { x: 100.25, y: 65.82 },
  },
  {
    id: "ozeti-residential-1",
    mapId: "ozeti",
    label: "Residential 1",
    kind: "landmark",
    at: { x: 97.61, y: 62.43 },
  },
  {
    id: "ozeti-residential-2",
    mapId: "ozeti",
    label: "Residential 2",
    kind: "landmark",
    at: { x: 98.99, y: 63.74 },
  },
  {
    id: "ozeti-residential-3",
    mapId: "ozeti",
    label: "Residential 3",
    kind: "landmark",
    at: { x: 101.67, y: 65.47 },
  },
  {
    id: "ozeti-residential-4",
    mapId: "ozeti",
    label: "Residential 4",
    kind: "landmark",
    at: { x: 102.59, y: 66.74 },
  },
  {
    id: "ozeti-residential-5",
    mapId: "ozeti",
    label: "Residential 5",
    kind: "landmark",
    at: { x: 99.07, y: 66.4 },
  },
  {
    id: "ozeti-residential-6",
    mapId: "ozeti",
    label: "Residential 6",
    kind: "landmark",
    at: { x: 99.5, y: 67.45 },
  },
  {
    id: "ozeti-residential-7",
    mapId: "ozeti",
    label: "Residential 7",
    kind: "landmark",
    at: { x: 103.13, y: 61.25 },
  },
  {
    id: "ozeti-residential-8",
    mapId: "ozeti",
    label: "Residential 8",
    kind: "landmark",
    at: { x: 101.05, y: 61.06 },
  },
  {
    id: "ozeti-residential-9",
    mapId: "ozeti",
    label: "Residential 9",
    kind: "landmark",
    at: { x: 97.03, y: 59.63 },
  },
  {
    id: "ozeti-shops-1",
    mapId: "ozeti",
    label: "Shops 1",
    kind: "landmark",
    at: { x: 99.81, y: 64.66 },
  },
  {
    id: "ozeti-shops-2",
    mapId: "ozeti",
    label: "Shops 2",
    kind: "landmark",
    at: { x: 101.46, y: 66.49 },
  },
  {
    id: "ozeti-stadium",
    mapId: "ozeti",
    label: "Stadium",
    kind: "landmark",
    at: { x: 97.76, y: 65.45 },
  },
  {
    id: "ozeti-stadium-garages",
    mapId: "ozeti",
    label: "Stadium Garages",
    kind: "landmark",
    at: { x: 97.23, y: 66.85 },
  },
  {
    id: "ozeti-tower-1",
    mapId: "ozeti",
    label: "Tower 1",
    kind: "tower",
    at: { x: 95.73, y: 62.86 },
  },
  {
    id: "ozeti-tower-2",
    mapId: "ozeti",
    label: "Tower 2",
    kind: "tower",
    at: { x: 100.36, y: 59.25 },
  },
  {
    id: "ozeti-tower-3",
    mapId: "ozeti",
    label: "Tower 3",
    kind: "tower",
    at: { x: 104.5, y: 63.73 },
  },
  {
    id: "ozeti-tower-4",
    mapId: "ozeti",
    label: "Tower 4",
    kind: "tower",
    at: { x: 100.69, y: 67.55 },
  },
  {
    id: "zestafona-apartments",
    mapId: "zestafona",
    label: "Apartments",
    kind: "landmark",
    at: { x: 68.03, y: 106.1 },
  },
  {
    id: "zestafona-brick-warehouses-1",
    mapId: "zestafona",
    label: "Brick Warehouses 1",
    kind: "landmark",
    at: { x: 72.21, y: 107.09 },
  },
  {
    id: "zestafona-brick-warehouses-2",
    mapId: "zestafona",
    label: "Brick Warehouses 2",
    kind: "landmark",
    at: { x: 72.83, y: 106.26 },
  },
  {
    id: "zestafona-brick-warehouses-3",
    mapId: "zestafona",
    label: "Brick Warehouses 3",
    kind: "landmark",
    at: { x: 74.43, y: 105.13 },
  },
  {
    id: "zestafona-bridge",
    mapId: "zestafona",
    label: "Bridge",
    kind: "landmark",
    at: { x: 72.14, y: 103.46 },
  },
  {
    id: "zestafona-bus-depot",
    mapId: "zestafona",
    label: "Bus Depot",
    kind: "landmark",
    at: { x: 71.69, y: 105.31 },
  },
  {
    id: "zestafona-factory-large-1",
    mapId: "zestafona",
    label: "Factory Large 1",
    kind: "landmark",
    at: { x: 70.39, y: 102.1 },
  },
  {
    id: "zestafona-factory-large-2",
    mapId: "zestafona",
    label: "Factory Large 2",
    kind: "landmark",
    at: { x: 71.44, y: 101.63 },
  },
  {
    id: "zestafona-farmland-1",
    mapId: "zestafona",
    label: "Farmland 1",
    kind: "landmark",
    at: { x: 75.05, y: 103.22 },
  },
  {
    id: "zestafona-farmland-2",
    mapId: "zestafona",
    label: "Farmland 2",
    kind: "landmark",
    at: { x: 77.85, y: 103.8 },
  },
  {
    id: "zestafona-farmland-3",
    mapId: "zestafona",
    label: "Farmland 3",
    kind: "landmark",
    at: { x: 74.86, y: 107.1 },
  },
  {
    id: "zestafona-farmland-4",
    mapId: "zestafona",
    label: "Farmland 4",
    kind: "landmark",
    at: { x: 69.02, y: 111.58 },
  },
  {
    id: "zestafona-farmland-5",
    mapId: "zestafona",
    label: "Farmland 5",
    kind: "landmark",
    at: { x: 81.34, y: 99.3 },
  },
  {
    id: "zestafona-farmland-6",
    mapId: "zestafona",
    label: "Farmland 6",
    kind: "landmark",
    at: { x: 78.15, y: 97.63 },
  },
  {
    id: "zestafona-farmland-7",
    mapId: "zestafona",
    label: "Farmland 7",
    kind: "landmark",
    at: { x: 75.63, y: 94.21 },
  },
  {
    id: "zestafona-forest-1",
    mapId: "zestafona",
    label: "Forest 1",
    kind: "landmark",
    at: { x: 74.56, y: 99.32 },
  },
  {
    id: "zestafona-forest-10",
    mapId: "zestafona",
    label: "Forest 10",
    kind: "landmark",
    at: { x: 74, y: 110.59 },
  },
  {
    id: "zestafona-forest-11",
    mapId: "zestafona",
    label: "Forest 11",
    kind: "landmark",
    at: { x: 63.12, y: 105.69 },
  },
  {
    id: "zestafona-forest-12",
    mapId: "zestafona",
    label: "Forest 12",
    kind: "landmark",
    at: { x: 64.81, y: 110.12 },
  },
  {
    id: "zestafona-forest-13",
    mapId: "zestafona",
    label: "Forest 13",
    kind: "landmark",
    at: { x: 61.14, y: 101.75 },
  },
  {
    id: "zestafona-forest-2",
    mapId: "zestafona",
    label: "Forest 2",
    kind: "landmark",
    at: { x: 72.84, y: 96.37 },
  },
  {
    id: "zestafona-forest-3",
    mapId: "zestafona",
    label: "Forest 3",
    kind: "landmark",
    at: { x: 69.57, y: 96.85 },
  },
  {
    id: "zestafona-forest-4",
    mapId: "zestafona",
    label: "Forest 4",
    kind: "landmark",
    at: { x: 67.13, y: 98.59 },
  },
  {
    id: "zestafona-forest-5",
    mapId: "zestafona",
    label: "Forest 5",
    kind: "landmark",
    at: { x: 64.23, y: 100.38 },
  },
  {
    id: "zestafona-forest-6",
    mapId: "zestafona",
    label: "Forest 6",
    kind: "landmark",
    at: { x: 65.88, y: 103.35 },
  },
  {
    id: "zestafona-forest-7",
    mapId: "zestafona",
    label: "Forest 7",
    kind: "landmark",
    at: { x: 67.36, y: 106.59 },
  },
  {
    id: "zestafona-forest-8",
    mapId: "zestafona",
    label: "Forest 8",
    kind: "landmark",
    at: { x: 68.56, y: 108.87 },
  },
  {
    id: "zestafona-forest-9",
    mapId: "zestafona",
    label: "Forest 9",
    kind: "landmark",
    at: { x: 71.21, y: 108.38 },
  },
  {
    id: "zestafona-import-scrap",
    mapId: "zestafona",
    label: "Import Scrap",
    kind: "landmark",
    at: { x: 68.58, y: 102.63 },
  },
  {
    id: "zestafona-offices-1",
    mapId: "zestafona",
    label: "Offices 1",
    kind: "landmark",
    at: { x: 73.26, y: 101.2 },
  },
  {
    id: "zestafona-offices-2",
    mapId: "zestafona",
    label: "Offices 2",
    kind: "landmark",
    at: { x: 73.14, y: 103.08 },
  },
  {
    id: "zestafona-offices-3",
    mapId: "zestafona",
    label: "Offices 3",
    kind: "landmark",
    at: { x: 73.91, y: 105.82 },
  },
  {
    id: "zestafona-resi-1",
    mapId: "zestafona",
    label: "Resi 1",
    kind: "landmark",
    at: { x: 66.94, y: 104.97 },
  },
  {
    id: "zestafona-resi-2",
    mapId: "zestafona",
    label: "Resi 2",
    kind: "landmark",
    at: { x: 67.4, y: 104 },
  },
  {
    id: "zestafona-resi-3",
    mapId: "zestafona",
    label: "Resi 3",
    kind: "landmark",
    at: { x: 74.38, y: 102.8 },
  },
  {
    id: "zestafona-shipping-exports-large",
    mapId: "zestafona",
    label: "Shipping Exports Large",
    kind: "landmark",
    at: { x: 72.79, y: 100.34 },
  },
  {
    id: "zestafona-shipping-exports-long",
    mapId: "zestafona",
    label: "Shipping Exports Long",
    kind: "landmark",
    at: { x: 70.7, y: 101.09 },
  },
  {
    id: "zestafona-shops-1",
    mapId: "zestafona",
    label: "Shops 1",
    kind: "landmark",
    at: { x: 73.4, y: 103.82 },
  },
  {
    id: "zestafona-shops-2",
    mapId: "zestafona",
    label: "Shops 2",
    kind: "landmark",
    at: { x: 69.26, y: 107.28 },
  },
  {
    id: "zestafona-tower-1",
    mapId: "zestafona",
    label: "Tower 1",
    kind: "tower",
    at: { x: 68.67, y: 104.28 },
  },
  {
    id: "zestafona-tower-2",
    mapId: "zestafona",
    label: "Tower 2",
    kind: "tower",
    at: { x: 72.85, y: 104.96 },
  },
  {
    id: "zestafona-tower-3",
    mapId: "zestafona",
    label: "Tower 3",
    kind: "tower",
    at: { x: 70.14, y: 100.16 },
  },
  {
    id: "zestafona-train-shed-1",
    mapId: "zestafona",
    label: "Train Shed 1",
    kind: "landmark",
    at: { x: 71.12, y: 99.8 },
  },
  {
    id: "zestafona-train-shed-2",
    mapId: "zestafona",
    label: "Train Shed 2",
    kind: "landmark",
    at: { x: 68.25, y: 101.89 },
  },
  {
    id: "zestafona-train-tracks",
    mapId: "zestafona",
    label: "Train Tracks",
    kind: "landmark",
    at: { x: 71.37, y: 100.27 },
  },
  {
    id: "zestafona-warehouse-8",
    mapId: "zestafona",
    label: "Warehouse 8",
    kind: "landmark",
    at: { x: 70.12, y: 106.93 },
  },
  {
    id: "zestafona-warehouse-small",
    mapId: "zestafona",
    label: "Warehouse Small",
    kind: "landmark",
    at: { x: 64.93, y: 106.84 },
  },
  {
    id: "zestafona-warehouses-1",
    mapId: "zestafona",
    label: "Warehouses 1",
    kind: "landmark",
    at: { x: 70.98, y: 103.49 },
  },
  {
    id: "zestafona-warehouses-2",
    mapId: "zestafona",
    label: "Warehouses 2",
    kind: "landmark",
    at: { x: 69.56, y: 103.71 },
  },
  {
    id: "zestafona-warehouses-3",
    mapId: "zestafona",
    label: "Warehouses 3",
    kind: "landmark",
    at: { x: 69.99, y: 105.31 },
  },
  {
    id: "zestafona-warehouses-4",
    mapId: "zestafona",
    label: "Warehouses 4",
    kind: "landmark",
    at: { x: 72.07, y: 102.47 },
  },
  {
    id: "zestafona-warehouses-5",
    mapId: "zestafona",
    label: "Warehouses 5",
    kind: "landmark",
    at: { x: 67.96, y: 100.44 },
  },
  {
    id: "zestafona-warehouses-6",
    mapId: "zestafona",
    label: "Warehouses 6",
    kind: "landmark",
    at: { x: 68.88, y: 100.79 },
  },
  {
    id: "zestafona-warehouses-7",
    mapId: "zestafona",
    label: "Warehouses 7",
    kind: "landmark",
    at: { x: 66.34, y: 102.02 },
  },
  {
    id: "zestafona-water-tower-1",
    mapId: "zestafona",
    label: "Water Tower 1",
    kind: "landmark",
    at: { x: 69.84, y: 99.01 },
  },
  {
    id: "zestafona-water-tower-2",
    mapId: "zestafona",
    label: "Water Tower 2",
    kind: "landmark",
    at: { x: 71.03, y: 98.44 },
  },
];
